var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { __assign } from "tslib";
import { InlineToolbarButtons, Plugins, PluginToolbarButtons, } from '../DaEditor/enums';
import { EditorFlavours } from './types';
import { Image } from './PluginComponents/Image';
import { Gallery } from './PluginComponents/Gallery';
import { getAnchorBlockPreview } from './PluginComponents/AnchorBlockPreview';
import { MediaSourceType } from '../MediaPopup/types';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import { isEmptyFeature, wordCountFeature, mediaCountFeature, firstImageFeature, } from './Features';
import { ToolbarType } from 'wix-rich-content-common';
import { Gif, Link, AddImage, CenterImage, FullWidthImage, FloatLeft, FloatRight, Edit, Delete, AddVideo, AddGallery, GalleryTorpedo, GalleryGrid, Settings, } from '../DaEditor/components/icons';
import { colorScheme, customBackgroundStyleFn, customForegroundStyleFn, styleSelectionPredicate, } from '../DaEditor/plugins/text-color-style-fn';
import PortalDecorator from '../DaEditor/components/PortalDecorator';
import { fetchUrlPreviewData } from '../DaEditor/plugins/plugin-link-preview/util';
import EmojiIcon from '@wix/da-ds/pkg/Icons/24x24/AddEmoticon';
var imageCanBeLinked = function (componentData, currentUser) {
    var _a;
    if (componentData && componentData.data) {
        // can be linked only if not published or the user owns it
        return (!componentData.data.isPublished ||
            ((_a = componentData.data.author) === null || _a === void 0 ? void 0 : _a.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId));
    }
    return true;
};
var imageCanBeFullWidth = function (componentData) {
    if (componentData && componentData.data && componentData.data.deviationId) {
        return getDeviationType(componentData.data) === DeviationTypes.IMAGE;
    }
    return true;
};
var giphyConfig = {
    toolbar: {
        icons: {
            InsertPluginButtonIcon: Gif,
            sizeContent: CenterImage,
            sizeFullWidth: FullWidthImage,
            sizeSmallLeft: FloatLeft,
            sizeSimallRight: FloatRight,
            link: Link,
            replace: Edit,
            delete: Delete,
        },
        hidden: [
            'sizeOriginal',
            'sizeFullWidth',
            'sizeContent',
            'separator1',
            'separator2',
        ],
    },
    giphySdkApiKey: 'dCf5MVSF00OQO1mlKr5DoNPO9OpOrlhj',
    componentDataDefaults: {
        config: {
            size: 'small',
            alignment: 'center',
        },
    },
    insertToolbars: [
        ToolbarType.SIDE,
        ToolbarType.FOOTER,
        ToolbarType.INSERT_PLUGIN,
    ],
};
var mentionConfig = {
    reposition: true,
    entryHeight: 40,
    additionalHeight: 0,
};
var linkConfig = {
    toolbar: {
        icons: {
            InsertPluginButtonIcon: Link,
        },
        hidden: [],
    },
};
var linkConfigWithAnchors = {
    toolbar: {
        icons: {
            InsertPluginButtonIcon: Link,
        },
        hidden: [],
    },
    linkTypes: {
        anchor: {
            blockPreview: getAnchorBlockPreview,
        },
    },
};
var linkPreviewConfig = {
    enableEmbed: true,
    fetchData: fetchUrlPreviewData,
    config: {
        size: 'content',
        alignment: 'center',
    },
    toolbar: {
        hidden: ['link'],
    },
};
var getImagePluginConfig = function (toolbarButtons, allowResize) {
    if (toolbarButtons === void 0) { toolbarButtons = [
        PluginToolbarButtons.BEST_FIT,
        PluginToolbarButtons.ALIGN_LEFT,
        PluginToolbarButtons.ALIGN_RIGHT,
        PluginToolbarButtons.SEPARATOR,
        PluginToolbarButtons.LINK,
        PluginToolbarButtons.SEPARATOR,
        PluginToolbarButtons.REPLACE,
        PluginToolbarButtons.DELETE,
        PluginToolbarButtons.REFRESH,
    ]; }
    if (allowResize === void 0) { allowResize = true; }
    return ({
        component: Image,
        canBeLinked: imageCanBeLinked,
        canBeFullWidth: imageCanBeFullWidth,
        allowResize: allowResize,
        toolbarButtons: toolbarButtons,
        toolbar: {
            hidden: [],
            icons: {
                InsertPluginButtonIcon: AddImage,
                sizeContent: CenterImage,
                sizeFullWidth: FullWidthImage,
                sizeSmallLeft: FloatLeft,
                sizeSimallRight: FloatRight,
                link: Link,
                replace: Edit,
                delete: Delete,
            },
        },
    });
};
var getVideoPluginConfig = function (toolbarButtons) {
    if (toolbarButtons === void 0) { toolbarButtons = [
        PluginToolbarButtons.BEST_FIT,
        PluginToolbarButtons.ALIGN_LEFT,
        PluginToolbarButtons.ALIGN_RIGHT,
        PluginToolbarButtons.SEPARATOR,
        PluginToolbarButtons.REPLACE,
        PluginToolbarButtons.DELETE,
    ]; }
    return ({
        toolbarButtons: toolbarButtons,
        toolbar: {
            hidden: [],
            icons: {
                InsertPluginButtonIcon: AddGallery,
                sizeContent: CenterImage,
                sizeFullWidth: FullWidthImage,
                sizeSmallLeft: FloatLeft,
                sizeSimallRight: FloatRight,
                add: Edit,
                delete: Delete,
            },
        },
    });
};
var getGalleryPluginConfig = function (toolbarButtons) {
    if (toolbarButtons === void 0) { toolbarButtons = [
        PluginToolbarButtons.BEST_FIT,
        PluginToolbarButtons.LAYOUT_GRID,
        PluginToolbarButtons.LAYOUT_MASONRY,
        PluginToolbarButtons.SEPARATOR,
        PluginToolbarButtons.REPLACE,
        PluginToolbarButtons.SETTINGS,
        PluginToolbarButtons.DELETE,
        PluginToolbarButtons.REFRESH,
    ]; }
    return ({
        component: Gallery,
        toolbarButtons: toolbarButtons,
        toolbar: {
            hidden: [],
            icons: {
                InsertPluginButtonIcon: AddVideo,
                sizeContent: CenterImage,
                sizeFullWidth: FullWidthImage,
                sizeSmallLeft: FloatLeft,
                sizeSimallRight: FloatRight,
                layoutGrid: GalleryGrid,
                layoutMasonry: GalleryTorpedo,
                advanced_settings: Settings,
                replace: Edit,
                delete: Delete,
            },
        },
    });
};
var emojiConfig = {
    toolbar: {
        icons: {
            InsertPluginButtonIcon: EmojiIcon,
        },
    },
};
var defaultFeatures = [
    isEmptyFeature,
    wordCountFeature,
    mediaCountFeature,
    firstImageFeature,
];
/**
 * Actual config
 *
 * taken from: https://docs.google.com/spreadsheets/d/1yLI5z0DtUlnLpMZlHqUFuynmOTpl1fkryQ4kg-CTUgI/edit?ts=5b291b5a#gid=0
 */
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var EditorFlavourConfigs = (_a = {},
    _a[EditorFlavours.Journal] = {
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.ALIGNMENT,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.TITLE,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
            InlineToolbarButtons.BLOCKQUOTE,
        ],
        featureConfig: [isEmptyFeature, wordCountFeature, mediaCountFeature],
        pluginsConfig: (_b = {},
            _b[Plugins.IMAGE] = getImagePluginConfig(),
            _b[Plugins.GALLERY] = getGalleryPluginConfig(),
            _b[Plugins.VIDEO] = getVideoPluginConfig(),
            _b[Plugins.EMOJI] = emojiConfig,
            _b[Plugins.EMOTES] = {},
            _b[Plugins.MENTION] = mentionConfig,
            _b[Plugins.LINK] = linkConfigWithAnchors,
            _b[Plugins.LINK_PREVIEW] = linkPreviewConfig,
            _b[Plugins.DIVIDER] = {},
            _b[Plugins.TEXT_COLOR] = {},
            _b[Plugins.GIPHY] = giphyConfig,
            _b[Plugins.HASHTAG] = {},
            _b[Plugins.SCROLLER] = {},
            _b[Plugins.DND_UPLOAD] = {},
            _b),
    },
    _a[EditorFlavours.Literature] = {
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.TITLE,
            InlineToolbarButtons.ALIGNMENT,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
            InlineToolbarButtons.BLOCKQUOTE,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_c = {},
            _c[Plugins.IMAGE] = getImagePluginConfig(),
            _c[Plugins.GALLERY] = getGalleryPluginConfig(),
            _c[Plugins.VIDEO] = getVideoPluginConfig(),
            _c[Plugins.EMOJI] = emojiConfig,
            _c[Plugins.EMOTES] = {},
            _c[Plugins.MENTION] = mentionConfig,
            _c[Plugins.LINK] = linkConfigWithAnchors,
            _c[Plugins.LINK_PREVIEW] = linkPreviewConfig,
            _c[Plugins.DIVIDER] = {},
            _c[Plugins.HASHTAG] = {},
            _c[Plugins.SCROLLER] = {},
            _c[Plugins.DND_UPLOAD] = {},
            _c),
    },
    _a[EditorFlavours.Status] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_d = {},
            _d[Plugins.IMAGE] = getImagePluginConfig(),
            _d[Plugins.GALLERY] = getGalleryPluginConfig(),
            _d[Plugins.VIDEO] = getVideoPluginConfig([
                PluginToolbarButtons.BEST_FIT,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _d[Plugins.EMOJI] = emojiConfig,
            _d[Plugins.EMOTES] = {},
            _d[Plugins.MENTION] = mentionConfig,
            _d[Plugins.LINK] = linkConfigWithAnchors,
            _d[Plugins.LINK_PREVIEW] = linkPreviewConfig,
            _d[Plugins.DIVIDER] = {},
            _d[Plugins.GIPHY] = giphyConfig,
            _d[Plugins.HASHTAG] = {},
            _d[Plugins.DND_UPLOAD] = {},
            _d),
    },
    _a[EditorFlavours.Comment] = {
        extraProps: {
            showMediaAlwaysSmall: true,
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_e = {},
            _e[Plugins.IMAGE] = getImagePluginConfig([
                PluginToolbarButtons.LINK,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ], false),
            _e[Plugins.GALLERY] = getGalleryPluginConfig([
                PluginToolbarButtons.LAYOUT_GRID,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _e[Plugins.VIDEO] = getVideoPluginConfig([
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _e[Plugins.EMOJI] = emojiConfig,
            _e[Plugins.EMOTES] = {},
            _e[Plugins.MENTION] = mentionConfig,
            _e[Plugins.LINK] = linkConfig,
            _e[Plugins.LINK_PREVIEW] = linkPreviewConfig,
            _e[Plugins.DIVIDER] = {},
            _e[Plugins.GIPHY] = __assign(__assign({}, giphyConfig), { toolbar: {
                    icons: {
                        InsertPluginButtonIcon: Gif,
                    },
                    hidden: [
                        'sizeOriginal',
                        'sizeFullWidth',
                        'sizeSmallLeft',
                        'sizeSimallRight',
                        'sizeSmallCenter',
                        'sizeContent',
                        'separator1',
                        'separator2',
                    ],
                } }),
            _e[Plugins.HASHTAG] = {},
            _e[Plugins.DND_UPLOAD] = {},
            _e),
    },
    _a[EditorFlavours.Commission] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_f = {},
            _f[Plugins.IMAGE] = getImagePluginConfig([
                PluginToolbarButtons.BEST_FIT,
                PluginToolbarButtons.ALIGN_LEFT,
                PluginToolbarButtons.ALIGN_RIGHT,
                PluginToolbarButtons.LINK,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _f[Plugins.GALLERY] = getGalleryPluginConfig(),
            _f[Plugins.VIDEO] = getVideoPluginConfig([
                PluginToolbarButtons.BEST_FIT,
                PluginToolbarButtons.ALIGN_LEFT,
                PluginToolbarButtons.ALIGN_RIGHT,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _f[Plugins.EMOJI] = emojiConfig,
            _f[Plugins.EMOTES] = {},
            _f[Plugins.LINK] = linkConfig,
            _f[Plugins.LINK_PREVIEW] = linkPreviewConfig,
            _f[Plugins.DIVIDER] = {},
            _f[Plugins.DND_UPLOAD] = {},
            _f),
        mediaSourceTypes: [MediaSourceType.GALLERY, MediaSourceType.STASH],
    },
    _a[EditorFlavours.DeviantId] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_g = {},
            _g[Plugins.IMAGE] = getImagePluginConfig(),
            _g[Plugins.GALLERY] = getGalleryPluginConfig(),
            _g[Plugins.VIDEO] = getVideoPluginConfig([
                PluginToolbarButtons.BEST_FIT,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _g[Plugins.EMOJI] = emojiConfig,
            _g[Plugins.EMOTES] = {},
            _g[Plugins.LINK] = linkConfig,
            _g[Plugins.MENTION] = mentionConfig,
            _g[Plugins.DND_UPLOAD] = {},
            _g),
    },
    _a[EditorFlavours.Deviation] = {
        extraProps: {
            showMediaAlwaysSmall: true,
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_h = {},
            _h[Plugins.IMAGE] = getImagePluginConfig([
                PluginToolbarButtons.LINK,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ], false),
            _h[Plugins.GALLERY] = getGalleryPluginConfig([
                PluginToolbarButtons.LAYOUT_GRID,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _h[Plugins.VIDEO] = getVideoPluginConfig([
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _h[Plugins.EMOJI] = emojiConfig,
            _h[Plugins.EMOTES] = {},
            _h[Plugins.MENTION] = mentionConfig,
            _h[Plugins.LINK] = linkConfig,
            _h[Plugins.LINK_PREVIEW] = linkPreviewConfig,
            _h[Plugins.DIVIDER] = {},
            _h[Plugins.GIPHY] = __assign(__assign({}, giphyConfig), { toolbar: {
                    icons: {
                        InsertPluginButtonIcon: Gif,
                    },
                    hidden: [
                        'sizeOriginal',
                        'sizeFullWidth',
                        'sizeSmallLeft',
                        'sizeSimallRight',
                        'sizeSmallCenter',
                        'sizeContent',
                        'separator1',
                        'separator2',
                    ],
                } }),
            _h[Plugins.HASHTAG] = {},
            _h[Plugins.DND_UPLOAD] = {},
            _h),
    },
    _a[EditorFlavours.PollAnswer] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [],
        featureConfig: defaultFeatures,
        pluginsConfig: (_j = {},
            _j[Plugins.EMOJI] = emojiConfig,
            _j[Plugins.EMOTES] = {},
            _j),
    },
    _a[EditorFlavours.Donation] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [InlineToolbarButtons.LINK],
        featureConfig: defaultFeatures,
        pluginsConfig: (_k = {},
            _k[Plugins.EMOJI] = emojiConfig,
            _k[Plugins.EMOTES] = {},
            _k[Plugins.LINK] = linkConfig,
            _k),
    },
    _a[EditorFlavours.CustomBox] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.TEXT_COLOR,
            InlineToolbarButtons.TEXT_HIGHLIGHT,
            InlineToolbarButtons.ALIGNMENT,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.TITLE,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
            InlineToolbarButtons.BLOCKQUOTE,
        ],
        textToolbarDecoratorFn: PortalDecorator({
            portalId: 'custombox-text-tools',
        }),
        featureConfig: defaultFeatures,
        pluginsConfig: (_l = {},
            _l[Plugins.IMAGE] = getImagePluginConfig(),
            _l[Plugins.GALLERY] = getGalleryPluginConfig(),
            _l[Plugins.VIDEO] = getVideoPluginConfig([
                PluginToolbarButtons.BEST_FIT,
                PluginToolbarButtons.ALIGN_LEFT,
                PluginToolbarButtons.ALIGN_RIGHT,
                PluginToolbarButtons.SEPARATOR,
                PluginToolbarButtons.REPLACE,
                PluginToolbarButtons.DELETE,
            ]),
            _l[Plugins.EMOJI] = emojiConfig,
            _l[Plugins.EMOTES] = {},
            _l[Plugins.MENTION] = mentionConfig,
            _l[Plugins.LINK] = linkConfigWithAnchors,
            _l[Plugins.LINK_PREVIEW] = linkPreviewConfig,
            _l[Plugins.DIVIDER] = {},
            _l[Plugins.HIGHLIGHT_COLOR] = {
                colorScheme: colorScheme,
                styleSelectionPredicate: styleSelectionPredicate,
                customStyleFn: customBackgroundStyleFn,
                onColorAdded: function (color) { return null; },
                getUserColors: function () { return []; },
                positionPicker: function (buttonRef, panelWidth) {
                    var editorWrapper = document.querySelector('[data-editor-key=customText]');
                    if (!editorWrapper || !buttonRef.current) {
                        return { left: 0, top: 0 };
                    }
                    var dialog = editorWrapper.closest('[role=dialog]');
                    if (!dialog) {
                        return { left: 0, top: 0 };
                    }
                    var modalRect = dialog.getBoundingClientRect();
                    var _a = buttonRef.current.getBoundingClientRect(), topButton = _a.top, leftButton = _a.left, heightButton = _a.height;
                    var topModal = modalRect.top, leftModal = modalRect.left;
                    var panelLeft = leftButton - leftModal - panelWidth / 2;
                    return {
                        left: Math.max(panelLeft, 2),
                        top: Math.max(topButton - topModal + heightButton, 50),
                    };
                },
            },
            _l[Plugins.TEXT_COLOR] = {
                colorScheme: colorScheme,
                styleSelectionPredicate: styleSelectionPredicate,
                customStyleFn: customForegroundStyleFn,
                onColorAdded: function (color) { return null; },
                getUserColors: function () { return []; },
                positionPicker: function (buttonRef, panelWidth) {
                    var editorWrapper = document.querySelector('[data-editor-key=customText]');
                    if (!editorWrapper || !buttonRef.current) {
                        return { left: 0, top: 0 };
                    }
                    var dialog = editorWrapper.closest('[role=dialog]');
                    if (!dialog) {
                        return { left: 0, top: 0 };
                    }
                    var modalRect = dialog.getBoundingClientRect();
                    var _a = buttonRef.current.getBoundingClientRect(), topButton = _a.top, leftButton = _a.left, heightButton = _a.height;
                    var topModal = modalRect.top, leftModal = modalRect.left;
                    var panelLeft = leftButton - leftModal - panelWidth / 2;
                    return {
                        left: Math.max(panelLeft, 2),
                        top: Math.max(topButton - topModal + heightButton, 50),
                    };
                },
            },
            _l[Plugins.GIPHY] = giphyConfig,
            _l[Plugins.HASHTAG] = {},
            _l[Plugins.INDENT] = {},
            _l[Plugins.DND_UPLOAD] = {
                pasteOnly: true,
            },
            _l),
    },
    _a[EditorFlavours.Chat] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
        ],
        textToolbarDecoratorFn: PortalDecorator({ portalId: 'chat-text-tools' }),
        featureConfig: defaultFeatures,
        pluginsConfig: (_m = {},
            _m[Plugins.LINK] = linkConfig,
            _m[Plugins.EMOTES] = {},
            _m[Plugins.MENTION] = mentionConfig,
            _m),
    },
    _a);
//# sourceMappingURL=config.js.map